import React from "react";
import { useTranslation } from "react-i18next";

const ProfileMenu = ({ activeSection, setActiveSection }) => {
  const { t } = useTranslation();

  const sections = [
    { key: "profile", label: t("profile.profile.value") },
    { key: "abo", label: t("profile.abo.value") },
    { key: "config", label: t("profile.config.value") },
    { key: "logout", label: t("profile.logout.value") },
  ];

  return (
    <nav className="profile-menu">
      <ul className="menu-horizontal">
        {sections.map(({ key, label }) => (
          <li
            key={key}
            className={activeSection === key ? "active" : ""}
            onClick={() => setActiveSection(key)}
          >
            {label}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ProfileMenu;
